import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Close} from '@radix-ui/react-toast';
import clsx from 'clsx';

type Props = React.ComponentPropsWithRef<typeof Close>;
export function ToastClose(props: Props): React.JSX.Element {
  return (
    <Close
      {...props}
      className={clsx([
        'rounded-md bg-slate1 text-slate9 [grid-area:close] hover:text-slate12 focus:text-slate11 focus:outline-hidden',
        props.className,
      ])}
    >
      <span className="sr-only">Close</span>
      <FontAwesomeIcon icon={faTimes} className="h-4 w-4" aria-hidden="true" />
    </Close>
  );
}

ToastClose.displayName = 'ToastClose';
